export default "__VITE_ASSET__DYUqwQ91__"